module.exports = __webpack_public_path__ + "static/img/img_logo.7e3c9d29.png";